import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageToggle.css';

/**
 * Language Toggle Component
 * Allows users to switch between English and Danish
 */
export default function LanguageToggle() {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    // Language change will be automatically saved to localStorage by i18next-browser-languagedetector
  };

  return (
    <div className="language-toggle">
      <button
        className={`language-btn ${currentLanguage === 'en' ? 'active' : ''}`}
        onClick={() => changeLanguage('en')}
        title="English"
      >
        🇬🇧 EN
      </button>
      <button
        className={`language-btn ${currentLanguage === 'da' ? 'active' : ''}`}
        onClick={() => changeLanguage('da')}
        title="Dansk"
      >
        🇩🇰 DA
      </button>
    </div>
  );
}

